const $detailsPage = $('#details');
const $sidebarLocator = $detailsPage.find('.sidebar_details');

const getDetailsPage = () => $detailsPage;

const getSidebarLocator = () => $sidebarLocator;

const formatPrice = (price) => !Odigeo._.isEmpty(price) && !Odigeo._.isNaN(price) ? parseFloat(price) : 0;

const getNumPassengers = () => Number($('.js-priceperpassenger').data('numtravellers')) || 1;

const getPricePerPassenger = (sumTotalPrice) => sumTotalPrice / getNumPassengers();

const isPrimeEnabled = () => Odigeo.Membership.isMembershipProductEnabled && !Odigeo.Utils.isRequestApp('dp') && !Odigeo.SessionScope.isMeta;

const isDiscountSelected = () => getDetailsPage().find('.details_manager_data').data('discountselected');

const isSlowLoadingPrimePriceFix = (isUpdatedMembershipPrices = false, membership = 0) => {
    return isPrimeEnabled() && isDiscountSelected() && !isUpdatedMembershipPrices && membership === 0;
};

class DefaultCalculator {
    get serviceFees() {
        const servicesFeePriceText = getSidebarLocator().find('.servicesfee:not(.hidden) .od-js-service-fee').attr('data-fee');
        return formatPrice(servicesFeePriceText);
    }

    get paymentFees() {
        const paymentFeePriceText = getSidebarLocator().find('.paymentfee:not(.hidden) .od-js-service-fee').attr('data-fee');
        const price = formatPrice(paymentFeePriceText);
        return price;
    }

    get promoCodes() {
        const promoCodePriceText = getSidebarLocator().find('.promocode_table .od-js-all-price').attr('data-all-price-promocode');
        return formatPrice(promoCodePriceText);
    }

    get membership() {
        const membershipSubscriptionPriceText = getSidebarLocator().find('.membership_subscription_table:not(.hidden) .od-js-all-price')
            .attr('data-all-price');
        return formatPrice(membershipSubscriptionPriceText);
    }

    get ticket() {
        return parseFloat(getDetailsPage().find('.js-total-price-ticket').data('priceticket')) || 0;
    }

    get discount() {
        return parseFloat(getDetailsPage().find('.od-js-discount-price').data('priceDiscount')) || 0;
    }

    get dynamicPackDiscount() {
        return parseFloat(getDetailsPage().find('.dynpack_fare_discount').data('dynpackfarediscount')) || 0;
    }

    get ancillaries() {
        return 0;
    }

    get total() {
        return this.totalWithoutAncillaries + this.ancillaries;
    }

    get totalWithoutAncillaries() {
        return this.ticket + this.serviceFees + this.paymentFees + this.discount + this.membership + this.promoCodes;
    }

    get totalWithoutDiscount() {
        return this.total + this.dynamicPackDiscount;
    }

    get passengerPrice() {
        return getPricePerPassenger(this.total);
    }

    getTotal(isUpdatedMembershipPrices = false) {
        return {
            sumTotalPrice: this.total,
            totalPriceWithoutDiscount: this.totalWithoutDiscount,
            totalWithoutAncillaries: this.totalWithoutAncillaries,
            totalWithoutAncillariesPerPassenger: getPricePerPassenger(this.totalWithoutAncillaries),
            pricePerPassenger: this.passengerPrice,
            isSlowLoadingPrimePriceFix: isSlowLoadingPrimePriceFix(isUpdatedMembershipPrices, this.membership),
        };
    }
}

module.exports = DefaultCalculator;
